import { useState, type InputHTMLAttributes } from 'react'
import { useLocale } from '../i18n/LocaleContext'

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const { t } = useLocale()
  const [visible, setVisible] = useState(false)
  const label = t(visible ? 'password.hide' : 'password.show')

  return (
    <div className="password-input">
      <input
        {...props}
        className={className}
        type={visible ? 'text' : 'password'}
      />
      <button
        type="button"
        className="password-visibility-button"
        aria-label={label}
        aria-pressed={visible}
        title={label}
        onClick={() => setVisible((current) => !current)}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          {visible ? (
            <>
              <path d="M3 3l18 18" />
              <path d="M10.6 10.7a2 2 0 0 0 2.7 2.7" />
              <path d="M9.9 4.3A11.8 11.8 0 0 1 12 4c5.2 0 8.6 4.6 9 6.2a4.9 4.9 0 0 1-.9 1.8M6.6 6.6C4.4 8 3.2 9.8 3 10.8 3.4 12.4 6.8 17 12 17a10 10 0 0 0 3.4-.6" />
            </>
          ) : (
            <>
              <path d="M3 12s3.2-6 9-6 9 6 9 6-3.2 6-9 6-9-6-9-6z" />
              <circle cx="12" cy="12" r="2.5" />
            </>
          )}
        </svg>
      </button>
    </div>
  )
}
